module.exports = __webpack_public_path__ + "img/64.9ea02ff1.jpg";